import {
    server
} from "@/api";

const prefix = 'api/onboarding'

export const get = async (params = {}) => {
    return await server().get(`${prefix}`, { params });
}

export const set = async (data) => {
    return await server().post(`${prefix}`, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

const onboardingApi = {
    get,
    set
}

export default onboardingApi;